export enum LoadingTechnique {
  // Waits for specified image size while showing shimmer
  SHIMMER = 'SHIMMER',
  // Shimmer while waiting for thumbnail to load, then load specified size when it is done downloading
  SHIMMER_THUMB = 'SHIMMER_THUMB',
  // Don't shimmer, load thumb, then load specified size when it is done downloading
  THUMB = 'THUMB'
}
